<template>
    <!-- εαν δεν υπάρχουν εκκρεμείς ανακοινωεις, εμφάνισε ένα μήνυμα-->
    <div v-if="show" class="alert alert-success alert-dismissible fade show col-md-8" role="alert" style="margin-left: 25%;">
            Δεν υπάρχουν ανακοινώσεις προς έγκριση.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- εαν υπάρχουν εκκρεμείς ανακοινωεις, εμφάνισε τον πίνακα με τις λεπτομέριες-->
    <div v-else class="container">
        <h2>Εμφάνιση ανακοινώσεων προς έγκριση</h2>
        <br>
        <br>

        <table class="table table-hover table-bordered"  id="table" data-toggle="table">
            <thead>
            <tr>
                <th>
                    Κωδικός Ανακοίνωσης
                </th>
                <th>
                    Τίτλος Ανακοίνωσης
                </th>
                <th>
                    ΔΕΠΣ
                </th>
                <th>
                    Ημερομηνία Δημοσίευσης
                </th>
                <th>
                    <!-- κουμπί επιλογής -->
                </th>
            </tr>
            </thead>

            <tbody>
            <tr id="sth" v-for="item in tbldata" :key="item.anakoinwshKwd">
                <td>{{item.anakoinwshKwd}}</td>
                <td>{{item.anakoinwshLek}}</td>
                <td id="name">{{item.sxhmatismosLek}}</td>
                <td id="username">{{ formatDate(item.anakoinwshDate) }}</td>
                <td>
                    <div>
                        <router-link type="button" class="btn btn-outline-primary" :to="{name:'view_me_announcement', params:{ id: item.anakoinwshKwd}}">
                            Εμφάνιση
                        </router-link>

                        <!-- Modal -->
                        <div class="modal fade" id="ModalApproveAnnouncement" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalScrollableTitle">
                                            Ανάγνωση δημοσίευσης
                                        </h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <h4>
                                            {{modal_header}}
                                        </h4>
                                        <br><br>
                                        {{modal_main_body}}
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-info mr-auto" data-dismiss="modal">Κλείσιμο</button>
                                        <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click.prevent="deletion">Οριστική Διαγραφή</button>
                                        <button type="button" class="btn btn-success" v-on:click.prevent="approve">Έγκριση Δημοσίευσης</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Toast Message for success-->
                        <div class="toast" id="success" aria-atomic="true" role="alert" aria-live="polite" style="position: absolute; top: 100px; right: 0;">
                            <div class="toast-header">
                                <strong style="color: #00e600;" class="mr-auto">Επιτυχία</strong>
                                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" v-on:click.prevent="close_toast">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="toast-body">
                                Η ανακοίνωση εγκρίθηκε.
                            </div>
                        </div>

                        <!-- Toast Message for delete-->
                        <div class="toast" id="delete" aria-atomic="true" role="alert" aria-live="polite" style="position: absolute; top: 100px; right: 0;">
                            <div class="toast-header">
                                <strong style="color: #ff3333;" class="mr-auto">Επιτυχία</strong>
                                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" v-on:click.prevent="close_toast">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="toast-body">
                                Η ανακοίνωση απορρίφθηκε.
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ValidateAnnouncementME",
        data(){
            return {
                show: false,
                tbldata: [],
                modal_main_body: "",
                modal_header: "",
                uid: "",
                counter: 0,
                options: {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}
            }
        },

        created() {
            if (!this.$store.getters.getToken) window.location.href = '/login';

            if (!this.$store.getters.isAdmin) this.$router.push('/');
        },

        mounted() {
            this.getPendingAnnouncements();
        },

        methods: {
            getPendingAnnouncements: function() {
                this.$store.dispatch('loading');
                this.$http.get("/announcements/pending/deps")
                    .then((response) => {
                        console.log(response);
                        var resp = response.data;
                        this.tbldata = resp.responseData;
                        this.$store.dispatch('stop_loading');
                    })
                    .catch((e) => {
                        console.error(e);
                        this.$store.dispatch('stop_loading');
                    });

                this.show = false;
            },
            modal: function (item) {
              this.modal_header = "ΜΕ που την δημοσίευσε: " + item.me;
              this.modal_main_body = item.announcement;
              this.uid = item.unique_id;

                $('#ModalApproveAnnouncement').modal('show');
            },

            close_toast: function () {
                // $('#success').toast('dispose');
                // $('#delete').toast('dispose');
            },

            formatDate: function(date) {
                let formattedDate = date.split("T")[0].split("-").reverse().join("/");
                return formattedDate;
            },
        }
    }
</script>

<style scoped>

</style>